import React, { useState, useEffect, useRef } from "react";

const ShareFileModal = ({ shareLink, onCancel }) => {
  const [copied, setCopied] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    // Auto-copy the link on mount.
    if (navigator.clipboard && shareLink) {
      navigator.clipboard.writeText(shareLink)
        .then(() => {
          setCopied(true);
          setTimeout(() => setCopied(false), 2000);
        })
        .catch((err) => {
          console.error("Failed to copy: ", err);
        });
    }
    // Also select the text in the input for manual copy.
    if (inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, [shareLink]);

  const handleCopy = () => {
    if (navigator.clipboard && shareLink) {
      navigator.clipboard.writeText(shareLink)
        .then(() => {
          setCopied(true);
          setTimeout(() => setCopied(false), 2000);
        })
        .catch((err) => console.error("Copy failed:", err));
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white dark:bg-gray-800 p-6 rounded shadow-lg w-96">
        <h2 className="text-xl dark:text-gray-200 font-bold mb-4">Share File</h2>
        <p className="mb-2 text-gray-600">Share Link:</p>
        <input
          ref={inputRef}
          type="text"
          value={shareLink}
          readOnly
          className="w-full p-2 border border-gray-300 rounded mb-4 focus:outline-none"
        />
        <div className="flex justify-end items-center space-x-4">
          <button
            onClick={onCancel}
            className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400 transition"
          >
            Close
          </button>
          <button
            onClick={handleCopy}
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition"
          >
            {copied ? "Copied!" : "Copy Link"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShareFileModal;